import { fetchCheckForUpdate } from "../components/shared/checkForUpdateApi"

 

export const getTodayDateKey = () => {
  return new Date().toISOString().split('T')[0]  
}

export const formatToYYYYMMDD = (dateString) => {
  const date = new Date(dateString)
  return date.toISOString().split('T')[0]
}

export const convertToYYYYMMDD = (dateString) => {
  const date = new Date(dateString)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
 
export const convertDate = (dateTime) => {
  const [datePart, time] = dateTime.split(' ')
  const [month, day, year] = datePart.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}


 export const checkIfDataAvailableData = async (date) => {
      try {
        const apiData = await fetchCheckForUpdate()
        
        const dateData = formatToYYYYMMDD(date)
      
        const hasTodayData = apiData?.find(item => item?.JsonData?.[dateData])
          console.log("data-->", apiData , hasTodayData, date ,dateData )
         return hasTodayData
      } catch (error) {
        console.error("Error checking update data:", error)
        
      }
    }

export const isTodayDataPresent = (apiData) => {
  const today = getTodayDateKey()
  return !!apiData?.[today]
}
 
export const getDefaultPatientData = () => ({
  POAC: false,
  HR: false,
  Incident: false,
  AppointmentStatus: 'Scheduled',
  NoteStatus : 'Draft'
})
 

export const appendPatientToToday = (
  data,
  { providerId, patientId ,date }
) => {
  const today = formatToYYYYMMDD(date)
 
  return {
    [today]: {
      ...(data?.[today] || {}),
      [providerId]: {
        ...(data?.[today]?.[providerId] || {}),
        [patientId]:
          data?.[today]?.[providerId]?.[patientId] ||
          getDefaultPatientData(),
      },
    },
  }
}
export const insertPatient = (data, { providerId, patientId , date }) => {
  const today = formatToYYYYMMDD(date)

  return {
    [today]: {
      ...(data[today] || {}),
      [providerId]: {
        ...(data[today]?.[providerId] || {}),
        [patientId]: getDefaultPatientData(),
      },
    },
  }
}

 
export const updatePatient = (data, { providerId, patientId, updates ,date}) => {
 
  const today = formatToYYYYMMDD(date)
      console.log("udpateDataGet",today , providerId, patientId, updates ,date,data)
  return {
    [today]: {
      ...(data[today] || {}),
      [providerId]: {
        ...(data[today]?.[providerId] || {}),
        [patientId]: {
          ...(data[today]?.[providerId]?.[patientId] || {}),
          ...updates,
        },
      },
    },
  }
}

 
export const deletePatient = (data, { providerId, patientId,date }) => {
  const today = formatToYYYYMMDD(date)

  const providerData = { ...(data[today]?.[providerId] || {}) }
  delete providerData[patientId]

  return {
    [today]: {
      ...(data[today] || {}),
      [providerId]: providerData,
    },
  }
}